import { ReactElement } from 'react';

import { SubtitleItem, SubtitleItemProps } from './Item';

type SubtitleProps = {
  children: ReactElement<SubtitleItemProps> | ReactElement<SubtitleItemProps>[];
  style?: React.CSSProperties;
};

export const Subtitle = ({ children, style }: SubtitleProps) => {
  return (
    <div className="subtitles" style={style}>
      {children}
    </div>
  );
};

Subtitle.Item = SubtitleItem;
